import { useQuery } from '@tanstack/react-query';
import { standardRequestWithErrorFlash } from 'shared/utils/request';
import { TemplateResponse } from 'candidate_profile_redesign/shared/types';

export const useEmailTemplate = (templatePath: string) => {
  return useQuery<TemplateResponse, Error>({
    queryKey: ['emailTemplates', templatePath],
    queryFn: async () => {
      const response = await standardRequestWithErrorFlash.get(templatePath);
      return response.data;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
};
